import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import SvgIcon from '../src/components/SvgIcon.vue';

const app = createApp(App);

app.use(router);

app.component('SvgIcon', SvgIcon);

app.mount('#app');
